module.exports = __webpack_public_path__ + "static/media/markerLocation.87426569.svg";